export default "/assets/images/wildfire-smoke-video.28de9e1fd3e2b222.mp4";